<template>
  <div v-if="show" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <div class="modal-header">
        <h5>{{ title }}</h5>
        <button type="button" class="btn-close" @click="closeModal"></button>
      </div>
      <div class="modal-body">
        <div
          class="image-container"
          @mousedown="startPan"
          @mousemove="pan"
          @mouseup="endPan"
        >
          <img
            :src="imageSrc"
            class="modal-image"
            :style="imageStyle"
            @wheel.prevent="handleZoom"
          />
        </div>
        <div class="zoom-controls">
          <button class="btn btn-sm btn-secondary" @click="zoomOut">
            <i class="bi bi-zoom-out"></i>
          </button>
          <button class="btn btn-sm btn-secondary mx-2" @click="resetZoom">
            <i class="bi bi-arrows-angle-contract"></i>
          </button>
          <button class="btn btn-sm btn-secondary" @click="zoomIn">
            <i class="bi bi-zoom-in"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    imageSrc: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: '画像の詳細表示'
    }
  },
  data() {
    return {
      scale: 1,
      translateX: 0,
      translateY: 0,
      isPanning: false,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0
    }
  },
  computed: {
    imageStyle() {
      return {
        transform: `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`,
        cursor: this.isPanning ? 'grabbing' : 'grab'
      }
    }
  },
  methods: {
    closeModal() {
      this.resetZoom()
      this.$emit('close')
    },
    handleZoom(event) {
      event.preventDefault()
      const delta = Math.sign(event.deltaY) * -0.1
      this.zoom(delta)
    },
    zoomIn() {
      this.zoom(0.1)
    },
    zoomOut() {
      this.zoom(-0.1)
    },
    zoom(delta) {
      const newScale = this.scale + delta
      if (newScale >= 0.5 && newScale <= 3) {
        this.scale = newScale
      }
    },
    resetZoom() {
      this.scale = 1
      this.translateX = 0
      this.translateY = 0
    },
    startPan(event) {
      this.isPanning = true
      this.startX = event.clientX - this.lastX
      this.startY = event.clientY - this.lastY
    },
    pan(event) {
      if (!this.isPanning) return

      this.translateX = event.clientX - this.startX
      this.translateY = event.clientY - this.startY
      this.lastX = this.translateX
      this.lastY = this.translateY
    },
    endPan() {
      this.isPanning = false
    }
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.resetZoom()
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 95vw;
  max-height: 95vh;
  overflow: hidden;
}

.modal-body {
  text-align: center;
  padding: 20px;
  overflow: hidden;
}

.image-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  user-select: none;
  -webkit-user-drag: none;
  transition: transform 0.1s;
}

.zoom-controls {
  position: sticky;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  padding: 10px;
  text-align: center;
  z-index: 1;
}
</style>
